import dayjs from 'dayjs'
import { getShipmentDisplayCalculated } from '../../../../helpers/entities/shipment/get-shipment-display-calculated'
import { Reasons } from '../../../../types/api/print-job-executor'
import Shipment from '../../../../types/api/shipment'
import { getPrintProgress } from './get-print-progress'

export interface PrintEndTime {
    endAt: string
    isEstimate: boolean
}

export function getPrintEndTime(shipment?: Shipment): PrintEndTime | undefined {
    const progress = getPrintProgress(shipment)
    const executors = shipment?.print_job?.print_job_executors || []

    if (progress === 'printed') {
        const ends = executors
            .filter(executor => executor.reason === Reasons.Done && executor.end)
            .map(executor => dayjs(executor.end).valueOf())
        if (ends.length === 0) return undefined

        return { endAt: dayjs(Math.max(...ends)).toISOString(), isEstimate: false }
    }

    if (progress === 'printing') {
        const starts = executors.map(executor => dayjs(executor.start).valueOf())
        if (starts.length === 0) return undefined

        const printingTime = getShipmentDisplayCalculated(shipment)?.printingTime ?? 0

        return {
            endAt: dayjs(Math.min(...starts))
                .add(printingTime, 'minute')
                .toISOString(),
            isEstimate: true,
        }
    }

    return undefined
}
